
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneakers/under-retail",
      function () {
        return require("private-next-pages/sneakers/under-retail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneakers/under-retail"])
      });
    }
  